import React from 'react';
import {
  CardMedia,
  Card,
  Button,
  CardActions
} from '@one-thd/sui-atomic-components';
import classNames from 'classnames';
import ListsHeader from '../ListsHeader';
import { defaultCardContentProps } from '../../../constants/responsiveClassNames';
import CreateNewList from '../CreateNewList';
import { NAVIGATION_URLS } from '../../../constants/navigationUrls';
import NullViewTexts from '../../../constants/NullViewTexts';
import NullViewContent from './NullViewContent';

const DesktopNullView = () => {
  const { imageAlt, imageUrl } = NullViewTexts;

  return (
    <Card
      data-component="Lists"
      data-testid="desktop-null-view"
      orientation="horizontal"
      className="sui-h-full"
      CardContentProps={{
        className: classNames(
          defaultCardContentProps,
          'sui-h-full',
          'sui-w-full'
        )
      }}
    >
      {/* eslint-disable-next-line react/no-unknown-property */}
      <div className="sui-flex sui-gap-4 sui-h-full sui-w-full sui-justify-between">
        <div className="sui-flex sui-flex-col sui-grow sui-gap-4 sui-h-full sui-min-w-max">
          <ListsHeader />
          <NullViewContent />
          <CardActions>
            <div className="sui-flex sui-gap-4 sui-text-nowrap">
              <Button fullWidth variant="secondary" href={NAVIGATION_URLS.LEARN_MORE}>Learn More</Button>
              <CreateNewList variant="button" />
            </div>
          </CardActions>
        </div>
        <div className="sui-basis-1/2 sui-max-w-md sui-overflow-hidden">
          <CardMedia
            src={imageUrl}
            alt={imageAlt}
            className={`sui-w-full sui-h-full sui-transform
                 sui-object-cover sui-object-center`}
          />
        </div>
      </div>
    </Card>
  );
};

DesktopNullView.propTypes = {};

export default DesktopNullView;
